import React from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {
  IconButton,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { TableSkeletonLoader } from "components/Table-skeleton-loader/TableSkeletonLoader";
import { useNavigate } from "hooks";
import { useDealActions } from "store";
import { IK1TableData } from "store/types";

interface K1TableProps {
  data: IK1TableData[];
  isLoading: boolean;
}

export const K1Table: React.FC<K1TableProps> = ({ data, isLoading: isK1TableLoading }) => {
  const { downloadFileAction } = useDealActions();
  const navigate = useNavigate();

  const handleDownload = (fileId: number, fileName: string, dealId: number) => {
    downloadFileAction({ fileId, fileName, dealId });
  };
  const handleNavigateToDeal = (dealId: number) => {
    navigate({ route: "deal", params: { deal_id: dealId } });
  };

  return (
    <Stack sx={{ maxHeight: 400 }}>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          position: "relative",
          overflow: "auto",
          border: "1px solid #DBE8F5",
          borderRadius: "8px",
          "& .MuiTable-root": {
            borderCollapse: "separate",
            borderSpacing: 0
          },
          "& .MuiTableHead-root .MuiTableCell-root": {
            backgroundColor: "#F7FAFD"
            // borderBottom: "1px solid #DBE8F5"
          },
          "& .MuiTableBody-root .MuiTableCell-root": {
            borderBottom: "1px solid #DBE8F5"
          },
          "& .MuiTableCell-root": {
            padding: "6px 16px"
          }
        }}
      >
        {isK1TableLoading ? (
          <TableSkeletonLoader rowsNum={7} />
        ) : (
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ padding: "0px 16px !important", height: "40px", fontSize: "16px", width: "45%" }}>
                  File Name
                </TableCell>
                <TableCell sx={{ padding: "0px 16px !important", height: "40px", fontSize: "16px", width: "45%" }}>
                  Altius Deal Name
                </TableCell>
                <TableCell sx={{ padding: "0px 16px !important", height: "40px", fontSize: "16px", width: "10%" }}>
                  Download
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.file_id} sx={{ height: "48px" }}>
                  <TableCell sx={{ padding: "0px 16px !important", fontSize: "16px", width: "45%" }}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        color: "#071f35",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {row.file_name}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ padding: "0px 16px !important", fontSize: "16px", width: "45%" }}>
                    <Link
                      onClick={() => handleNavigateToDeal(row.deal_id)}
                      sx={{
                        fontSize: "16px",
                        color: "#26a6ae",
                        textDecoration: "none",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                        "&:hover": {
                          textDecoration: "underline"
                        }
                      }}
                    >
                      {row.deal_name}
                    </Link>
                  </TableCell>
                  <TableCell sx={{ padding: "0px 16px !important", width: "10%" }}>
                    <IconButton
                      onClick={() => handleDownload(row.file_id, row.file_name, row.deal_id)}
                      sx={{
                        padding: "4px",
                        borderRadius: "32px",
                        "&:hover": {
                          bgcolor: "transparent"
                        }
                      }}
                    >
                      <DescriptionOutlinedIcon sx={{ fontSize: "16px", color: "#071f35" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </Stack>
  );
};
